import viagsApiDev from "../../chats/api/axiosClientdev";
import { DataRecord, GetContactPayload } from "../types";
import { Contact } from "../types/contact";

export const contactApi = {
  getContacts: async (body: GetContactPayload) => {
    const response = await viagsApiDev.post<DataRecord<Contact[]>>("/api/chat/get-contacts", body);
    return response.data;
  },
};
